<script>
export default {
  name: 'ProductDetails',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      quantity: 1,
      shouldShowConfirm: false,
    }
  },
  computed: {},
  methods: {
    confirm() {
      this.$emit('delete-product', {
        product_id: this.product.id,
      })
      this.$emit('close')
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="product-details bg-white rounded-xl mx-auto shadow-box relative left-0 flex justify-between overflow-hidden"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div class="mb-5">
        <div class="px-8 pb-3">
          <div class="text-gray-light text-2xl mt-10">
            Confirmation
          </div>
          <div class="flex justify-between">
            <div class="mt-3">
              <p class="my-3 text-black text-basel">
                You are about to delete
                <span class="font-bold">{{ product.title }}</span
                >.</p
              ><p>Are you sure?</p>
              <p class="my-3 text-black text-basel font-bold">
                This cannot be undone.</p
              >
            </div>
          </div>
          <div class="mt-3">
            <button
              class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="confirm"
              >Delete</button
            >
            <button
              class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
              @click="$emit('close')"
              >Cancel</button
            >
          </div>
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>
